import type { ReactElement } from 'react'

import Link from 'next/link'

import { Container } from '@ui/components/Container'
import { Seo } from '@ui/components/seo'
import { HeroBasic } from '@ui/hero'
import { MarketingLayout } from '@ui/layout/MarketingLayout'

import { getMarkdownLinks, MarkdownLink } from '@website/utils/markdown'

const title = 'Financial Guides'
const description =
  'Explore practical financial guides and resources to help you manage your money better.'

export async function getStaticProps() {
  const markdownLinks = getMarkdownLinks()

  return {
    props: {
      markdownLinks,
    },
  }
}

export function Index({ markdownLinks }: { markdownLinks: MarkdownLink[] }) {
  return (
    <>
      <Seo title={title} description={description} />
      <div className="relative bg-[url('/img/our-mission-bg.svg')] bg-cover bg-center pt-[120px]">
        <HeroBasic
          className="!bg-transparent"
          title={
            <span className="font-display tracking-wider text-[#0a2d4a]">
              GUIDES
            </span>
          }
        />
      </div>
      <div className="bg-white">
        <Container>
          <div className="mx-auto max-w-3xl py-20">
            <ul className="m-0 list-disc space-y-4 pl-4">
              {markdownLinks.map(({ slug, title, subtitle }) => (
                <li key={slug} className="m-0 p-0">
                  <Link href={`/${slug}`} className="no-underline">
                    <div className="text-blueberry-700 text-lg font-medium">
                      {title}
                    </div>
                    {subtitle && (
                      <div className="text-[#0a2d4a]">{subtitle}</div>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </Container>
      </div>
    </>
  )
}

Index.getLayout = (page: ReactElement) => (
  <MarketingLayout chin="white" mainClassName="-mt-[120px]">
    {page}
  </MarketingLayout>
)

export default Index
